import React from 'react';
import PropTypes from 'prop-types';
import Ad from '@ifeng/ui_pc_ad';
import Chip from 'Chip';
import errorBoundary from '@ifeng/errorBoundary';
import Loadable from 'react-loadable';
import LazyLoad from '@ifeng/ui_pc_lazyLoad';
import styles from './index.css';
import Artical from './artical';
import Request from './request';
import Goodbook from './goodbook';

const LoadPPLive = Loadable({
    loader: () => import('./ppLive'),
    loading() {
        return <div />;
    },
});

class LeftContent extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const { content } = this.props;
        const {
            article,
            article: { searchPath },
            page_ppposiiton_live3,
            commentPPX,
            goodbook0,
            contentAd,
            infoAd,
            hardAd,
            serviceAd,
            contentBottomAd,
        } = content;

        // 佛教无为您推荐内容
        return (
            <div className={styles.leftContent}>
                <Artical content={article} ad={contentAd} commentPPX={commentPPX} />
                <div className={styles.space30} />
                {searchPath.indexOf('16-') === 0 ? null : <Request ad={infoAd} />}
                <div className={styles.space40} />
                <div>
                    <Ad content={hardAd} styleName={styles.hardAd} />
                    <Ad content={serviceAd} styleName={styles.serviceAd} />
                    <Ad content={contentBottomAd} styleName={styles.contentBottomAd} />
                </div>
                <div className={styles.space25} />
                {page_ppposiiton_live3 ? (
                    <LazyLoad>
                        <LoadPPLive title="泡泡直播" tag="page_ppposiiton_live3" content={page_ppposiiton_live3} />
                    </LazyLoad>
                ) : (
                    ''
                )}
                {goodbook0 ? (
                    <Chip
                        id="55001"
                        type="recommend"
                        title="正文好书精选"
                        groupName="正文"
                        position="relative"
                        content={goodbook0}
                        translate="handleGoodbookData">
                        <Goodbook />
                    </Chip>
                ) : (
                    ''
                )}
            </div>
        );
    }
}

export default errorBoundary(LeftContent);
